import { render } from "./HistoryMain.vue?vue&type=template&id=3cbaa140&scoped=true"
import script from "./HistoryMain.vue?vue&type=script&lang=js"
export * from "./HistoryMain.vue?vue&type=script&lang=js"

import "./HistoryMain.vue?vue&type=style&index=0&id=3cbaa140&scoped=true&lang=css"

import exportComponent from "/Users/tycooper/Desktop/Coding/Suites/barkbadge/barkbadge-wholesale/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cbaa140"]])

export default __exports__